(ns dashboard.components.file-upload.subs
  (:require [re-frame.core :as rf]))

(rf/reg-sub
  ;; TODO: Rename to say aggregated-upload-status, since this if over all selected files
  ::upload-status
  (fn [db [_ file-type]]
    (get-in db [:upload file-type :upload-status])))

(defn get-selected-files-sorted
  ([db file-type] (get-selected-files-sorted db file-type []))
  ([db file-type existing-files]
   (let [existing-file-names (set (map :filename existing-files))]
     (->> (get-in db [:upload file-type :files])
          (filter #(not (contains? existing-file-names (first %))))
          (sort-by key)))))

(rf/reg-sub
  ::selected-files
  (fn [db [_ file-type]]
    (get-selected-files-sorted db file-type)))
